<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsProcessTaskStandardId'"
        :showDisplayCountControl="false"
        :showMoveControl="true"
        :multiselect="true"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowAdd"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowDelete"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
        </div>
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
    processTaskStandardIdInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PRC_TASK_STNRD_ID_ITEM_VAL'),
        datafield: 'processTaskStandardIdItemValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
            },
            this.dsProcessTaskStandardId, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRC_TASK_STNRD_ID_ITEM_NM'),
        datafield: 'processTaskStandardIdItemName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
            },
            this.dsProcessTaskStandardId, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsProcessTaskStandardId',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'processTaskStandardIdItemUid', map: 'processTaskStandardIdItemUid' },
      { type: 'string', name: 'processTaskStandardIdItemValue', map: 'processTaskStandardIdItemValue' },
      { type: 'string', name: 'processTaskStandardIdItemName', map: 'processTaskStandardIdItemName' },
      { type: 'string', name: 'processTaskStandardIdItemOrder', map: 'processTaskStandardIdItemOrder' },
      { type: 'string', name: 'workflowId', map: 'workflowId' }],
  }],
  mounted() {
    this.$nextTick(() => {
      this.setProcessTaskStandardId();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * Grid Button Event
     */
    onClickRowAdd() {
      const defaultRow = [{
        processTaskStandardIdItemValue: '',
        processTaskStandardIdItemName: '',
      }];
      this.dsProcessTaskStandardId.addRows(defaultRow);
    },
    onClickRowDelete() {
      const selectedIndexes = this.dsProcessTaskStandardId.getSelectedIndexes();
      this.dsProcessTaskStandardId.deleteRows(selectedIndexes);
    },
    /**
     * 업무기준 ID 정보 SET
     * 입력 중인 데이터(processTaskStandardIdSaveList)가 없으면
     * ID기준으로 업무기준ID 정보 조회
     */
    setProcessTaskStandardId() {
      if (!utils.isUndefined(this.processTaskStandardIdInfo.processTaskStandardIdSaveList)
      && !utils.isEmpty(this.processTaskStandardIdInfo.processTaskStandardIdSaveList)) {
        const cloneData = utils.clone(this.processTaskStandardIdInfo.processTaskStandardIdSaveList);
        this.dsProcessTaskStandardId.setRawData(cloneData);
      } else if (!utils.isEmpty(this.selectedRowData.workflowId)) {
        this.searchProcessTaskStandardId();
      }
    },
    searchProcessTaskStandardId() {
      http.request(this.pageId, 'DTS_CMR_00031', {
        path: {
          'workflow-id': this.selectedRowData.workflowId,
        },
      }).then(res => {
        this.dsProcessTaskStandardId.submit();
        this.dsProcessTaskStandardId.setRawData(res.data);
      });
    },
    /**
     * 취소
     */
    onClickCancel() {
      this.$emit('popupClose');
    },
    /**
     * 적용
     */
    onClickApply() {
      const { data } = this.dsProcessTaskStandardId;
      let deleteList = [];

      if (!this.validationCheck()) return false;

      if (!utils.isUndefined(this.processTaskStandardIdInfo.processTaskStandardIdDeleteList)
      && !utils.isEmpty(this.processTaskStandardIdInfo.processTaskStandardIdDeleteList)) {
        deleteList = this.processTaskStandardIdInfo.processTaskStandardIdDeleteList;
      }
      deleteList = utils.union(deleteList, this.dsProcessTaskStandardId.getRemovedRows());

      utils.forEach(data, (key, value) => {
        data[value].processTaskStandardIdItemOrder = value + 1;
      });

      if (data.length > 0) {
        this.$emit('paramReturn', {
          value: utils.join(utils.map(data, 'processTaskStandardIdItemName'), '|'),
          processTaskStandardIdDeleteList: utils.clone(deleteList),
          processTaskStandardIdSaveList: utils.clone(data),
        }, 'processTaskStandardIdInfo');
        this.$emit('popupClose');
      } else {
        // 선택 안했을 때
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));// 선택 된 항목이 없습니다.
      }

      return null;
    },
    /**
     * 입력 체크
     */
    validationCheck() {
      let flag = true;

      utils.forEach(this.dsProcessTaskStandardId.data, (obj, row) => {
        if (utils.isEmpty(obj.processTaskStandardIdItemValue)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRC_TASK_STNRD_ID_ITEM_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'processTaskStandardIdItemValue');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.processTaskStandardIdItemName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRC_TASK_STNRD_ID_ITEM_NM')),
          null,
          () => {
            this.gridSetFocus(row, 'processTaskStandardIdItemName');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
  },
};
</script>
<style scoped>
</style>
